export default {
  organization: {
    pages: {
      '_admin-manage-product': {
        title: 'Administrar Organización',
        actions: {
          save_changes: 'Guardar Cambios',
          new_contact: 'Nuevo Contacto',
        },
        labels: {
          contact_title: 'Información de Contacto',
        },
        tabs: {
          contacts: 'Contactos',
          address: 'Dirección',
          others: 'Otros',
          terms: 'Términos y Condiciones',
        },
      },
      'public-profile': {
        title: 'Ficha Pública',
        general: 'Información de General',
        contact: 'Información de Contacto',
        other: 'Otra Información',
        actions: {
          contact: 'Contactar',
        },
      },
    },
    entity: {
      name: 'Nombre',
      tax_id: 'Rut',
      website: 'Sitio web',
      address: 'Dirección Casa Matriz',
      created_at: 'Fecha Creación Empresa',
      last_year_of_billing: 'Facturación del último año (Pesos Chilenos)',
      description: 'Descripción de la empresa',
      contact: {
        name: 'Nombre',
        email: 'Email',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/organization.js